import React from "react";
import "./Blogs.scss";
import { Link } from 'react-router-dom';

const BlogCard = ({ blog, categories }) => (
  <Link to={`/blogs/${blog.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
    <div className="blog-card">
      <div className="blog-card__content">
        <div style={{ flex: 1, minWidth: 0 }}>
          <h3 className="blog-card__title">{blog.title?.rendered}</h3>
          <div className="blog-card__tags">
            {blog.categories && blog.categories.map((category, index) => (
              <span key={index} className="blog-tag-pill">{categories.find(c => c.id === category)?.name}</span>
            ))}
          </div>
          <div className="blog-card__desc" dangerouslySetInnerHTML={{ __html: blog.excerpt?.rendered || '' }} />
          <div className="d-flex justify-content-between">
            <div className="blog-card__meta">
              <span>👁 {blog.view_count || 0} Views</span>
              <span>📅 {blog.date ? new Date(blog.date).toLocaleDateString() : 'No date available'}</span>
            </div>
            <button className="blog-card__share">Share With Others</button>
          </div>
        </div>
        <div className="blog-card__image-wrapper">
          <img
            className="blog-card__image"
            src={blog?.featured_image || require('../../assets/images/blogdummy.jpeg')}
            alt={blog.title?.rendered || 'Blog image'}
            style={{ width: 300, height: 180, objectFit: 'cover', borderRadius: 16 }}
          />
        </div>
      </div>
    </div>
  </Link>
);

export default BlogCard; 